export const defaultPromotionDetail = {
  id: '',
  active: false,
  analytics: null,
  name: '',
  representativeFeature: null,
  privateTitle: null,
  code: '',
  status: '',
  currency: '',
  timeZone: '',
  description: '',
  designations: [],
  effectivePeriod: null,
  type: '',
  incentive: null,
  offer: {},
  searchCondition: {},
  paymentMethods: [],
  enableBinInput: null,
  binNumbers: null,
  promotionCap: {},
  promotionBudget: {},
  applicablePlans: [],
  applyToAllProviders: true,
  updateDateTime: '',
  createDateTime: '',
  userCondition: {},
  platformCondition: {},
  ancestors: [],
  participationExclusive: false,
};

export const defaultPromotionDeletable = {
  message: '',
  statusCode: null,
};

export const defaultDeletableDialog = {
  isShow: false,
};
